import { Action, configureStore, ThunkAction, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import authReducer from './Reducers/Organization/AuthReducer';

// Step 1: Create the root reducer with combineReducers
const rootReducer = combineReducers({
    auth: authReducer
});

// Step 2: Configure persist settings
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'], // Only persist the auth reducer
};

// Step 3: Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Step 4: Configure store with persisted reducer
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Necessary to ignore non-serializable actions from redux-persist
        }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  undefined,
  Action<string>
>;
export type AppDispatch = typeof store.dispatch;

export default store;
